export default function normalizeString(str: string) {
  return str
    ?.normalize("NFD")                // split characters and diacritics
    .replace(/[\u0300-\u036f]/g, "")  // remove accents
    .toLowerCase()
    .replace(/\s+/g, "");             // ignore spaces
}